<template>
  <div>
    <div class="weituo">
      <i class="el-icon-location-information" style="color: #63b947; font-size: 25px"></i>
      <p class="tittype">{{$t('i18n_location_information')}}</p>
    </div>
    <el-form label-position="right" label-width="95px" size="small" :model="getGoodsDTO" :rules="getGoodsDTORules" ref="getGoodsInfo">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('i18n_consignee_information')">
            <div style="width: 100%; box-sizing: border-box">
              <div class="poperWrap" v-show="!sendFeeForAir.name">
                {{$t('i18n_No_default_contact')}}
                <el-button
                  style="color: #604aff"
                  type="text"
                  @click="addNewpop(3)"
                >{{$t('i18n_add')}}</el-button>
              </div>
              <!-- 当前展示的联系人 -->
              <div
                class="thatpoperWrap"
                v-show="sendFeeForAir.name"
              >
                <div class="popWrap_l">
                  <p class="lianxiren">{{ sendFeeForAir.name }}</p>
                  <p style="margin-left: 12px">{{ sendFeeForAir.tel }}</p>
                  <p class="overText" style="margin-left: 20px">
                    {{ sendFeeForAir.country }}{{ sendFeeForAir.city
                    }}{{ sendFeeForAir.area }}{{ sendFeeForAir.address }}
                  </p>
                </div>
                <div class="popWrap_R">
                  <span class="morentype" v-show="sendFeeForAir.isdefault"
                    >{{$t('i18n_default_address')}}</span>
                  <el-button
                    v-show="!sendFeeForAir.isdefault"
                    style="color: #604aff"
                    type="text"
                    @click.stop="changeshowType(3, sendFeeForAir, 'loca')"
                  >{{$t('i18n_set_to_default_address')}}</el-button>
                  <el-button
                    style="color: #604aff"
                    type="text"
                    @click.stop="UpItem(3, sendFeeForAir)"
                  >{{$t('i18n_edit')}}</el-button>
                  <el-button
                    style="color: #604aff"
                    type="text"
                    @click="addNewpop(3)"
                  >{{$t('i18n_add')}}</el-button>
                </div>
              </div>
              <!-- 当前展示的联系人 -->
              <!-- 当前可选的联系人 -->
              <el-collapse-transition>
                <div v-show="showReceive">
                  <div
                    class="poperWrap"
                    v-for="(item, index) in SHpopList"
                    :key="index"
                    @click="changeShitem(item)"
                  >
                    <div class="popWrap_l">
                      <p class="lianxiren">{{ item.name }}</p>
                      <p style="margin-left: 12px">{{ item.tel }}</p>
                      <p class="overText" style="margin-left: 20px">
                        {{ item.country }}{{ item.city }}{{ item.area
                        }}{{ item.address }}
                      </p>
                    </div>
                    <div class="popWrap_R">
                      <span class="morentype" v-show="item.isdefault"
                      >{{$t('i18n_default_address')}}</span>
                      <el-button
                        v-show="!item.isdefault"
                        style="color: #604aff"
                        type="text"
                        @click.stop="changeshowType(3, item, 'ajax')"
                      >{{$t('i18n_set_to_default_address')}}</el-button>
                      <el-button
                        style="color: #604aff"
                        type="text"
                        @click.stop="UpItem(3, item)"
                      >{{$t('i18n_edit')}}</el-button>
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
            <div
              style="margin: 10px 0 0 10px"
              v-show="SHpopList.length > 1"
            >
              <el-button
                @click="showReceive = !showReceive"
                style="color: #696969"
                type="text"
                >{{ $t(showReceive ? "i18n_Collapse" : "i18n_more_consignee_information") }}</el-button
              ><span
                :class="showReceive ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              ></span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- 发货展示 -->
          <el-form-item :label="$t('i18n_shipper_information')">
            <div style="width: 100%; box-sizing: border-box">
              <div class="poperWrap" v-show="countLIst_S.name == ''">
                {{$t('i18n_No_default_contact')}}
                <el-button
                  @click="addNewpop(1)"
                  type="text"
                  style="color: #604aff"
                >{{$t('i18n_add')}}</el-button>
              </div>
              <div
                class="thatpoperWrap"
                v-show="countLIst_S.name"
              >
                <div class="popWrap_l">
                  <p class="lianxiren">{{ countLIst_S.name }}</p>
                  <p style="margin-left: 12px">{{ countLIst_S.tel }}</p>
                </div>
                <div class="popWrap_R">
                  <span class="morentype" v-show="countLIst_S.isdefault">{{$t('i18n_default_address')}}</span>
                  <el-button
                    v-show="!countLIst_S.isdefault"
                    style="color: #604aff"
                    type="text"
                    @click.stop="changeshowType(1, countLIst_S, 'loca')"
                  >{{$t('i18n_set_to_default_address')}}</el-button>
                  <el-button
                    style="color: #604aff"
                    type="text"
                    @click="UpItem(1, countLIst_S)"
                  >{{$t('i18n_edit')}}</el-button>
                  <el-button
                    @click="addNewpop(1)"
                    type="text"
                    style="color: #604aff"
                  >{{$t('i18n_add')}}</el-button>
                </div>
              </div>
              <!-- 发货供选 -->
              <el-collapse-transition>
                <div v-show="showFa">
                  <div
                    class="poperWrap"
                    v-for="(item, index) in FapopList"
                    :key="index"
                    @click="changeFAitem(item)"
                  >
                    <div class="popWrap_l">
                      <p class="lianxiren">{{ item.name }}</p>
                      <p style="margin-left: 12px">{{ item.tel }}</p>
                    </div>
                    <div class="popWrap_R">
                      <span class="morentype" v-show="item.isdefault"
                        >{{$t('i18n_default_address')}}</span
                      >
                      <el-button
                        v-show="!item.isdefault"
                        style="color: #604aff"
                        type="text"
                        @click.stop="changeshowType(1, item, 'ajax')"
                        >{{$t('i18n_set_to_default_address')}}</el-button
                      >
                      <el-button
                        style="color: #604aff"
                        type="text"
                        @click.stop="UpItem(1, item)"
                        >{{$t('i18n_edit')}}</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
            <div style="margin: 10px 0 0 10px" v-show="FapopList.length > 1">
              <el-button
                @click="showFa = !showFa"
                style="color: #696969"
                type="text"
                >{{ $t(showFa ? "i18n_Collapse" : "i18n_More_consignor_information") }}</el-button
              ><span
                :class="showFa ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              ></span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('i18n_door_to_door_pickup_service')" label-width="125px">
            <el-radio-group size="mini" v-model="toDoorForm.isGetGoodsToDoor" @change="changeTi">
              <el-radio-button :label="false">{{$t('i18n_no')}}</el-radio-button>
              <el-radio-button :label="true">{{$t('i18n_yes')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="送货上门">
            <el-radio-group size="mini" v-model="toDoorForm.isSendGoodsToDoor" @change="changeSh">
              <el-radio-button :label="true">是</el-radio-button>
              <el-radio-button :label="false">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
        <div v-if="toDoorForm.isGetGoodsToDoor === true" style="float: left; width: 100%">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('i18n_pickup_location')" prop="getGoodsAddress">
                <el-input v-model="getGoodsDTO.getGoodsAddress">
                  <el-button slot="append" style="background-color: #5ab53c; color: #fff" @click="ShowTHList">{{$t('i18n_address_book')}}</el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('i18n_pickup_time')" prop="toDoorDate">
                <el-date-picker
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :placeholder="addPls('i18n_pickup_time', 'select')"
                  v-model="toDoorForm.toDoorDate"
                  style="width: 100%"
                  :picker-options="pickerSetTime"
                  @change="toDoorDateChange"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('i18n_pickup_person')" prop="getGoodsName">
                <el-input v-model="getGoodsDTO.getGoodsName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('i18n_contact_number')" prop="getGoodsTel">
                <el-input v-model="getGoodsDTO.getGoodsTel"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <!-- 请将货物送至以下仓库 -->
          <el-col :span="24">
            <div class="SHInfo" v-if="cangkuitem.namec">
              <p>{{$t('i18n_send_goods_to_following_address')}}:</p>
              <p>{{$t('i18n_Warehouse_Address')}}：{{cangkuitem.addressc}}, {{$t('i18n_contact_number')}}：{{cangkuitem.tel}}</p>
            </div>
          </el-col>
        </div>
      </el-row>
    </el-form>

    <!-- 提货人地址 -->
    <el-dialog
      :visible.sync="showMydialog"
      :title="$t('i18n_pickup_address')"
      class="myDialog"
    >
      <div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin: 0 0 20px 0;
          "
        >
          <div>
            <el-input
              clearable
              @clear="getPeopletable()"
              v-model="nameOrPhone"
              @keyup.native="searchNameOrPhone"
              :placeholder="$t('i18n_name_or_phone_number')"
              size="medium"
              style="width: 390px"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
              <el-button slot="append" type="primary">{{$t('i18n_Search')}}</el-button>
            </el-input>
          </div>

          <el-button size="medium" plain type="primary" @click="showAdd(true)"
            >{{$t('i18n_Create_new_address')}}</el-button
          >
        </div>
        <!-- 新增或编辑 -->
        <div
          v-if="edit"
          style="
            background-color: #fff;
            border-radius: 20px;
            padding: 20px;
            box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
          "
        >
          <div style="width: 85%; margin: 0 auto; max-width: 600px">
            <el-row
              :gutter="20"
              style="margin-bottom: 8px; margin-left: 1px; display: flex"
            >
              <div style="display: flex">
                <div
                  class="grid-content"
                  style="margin-right: 5px; min-width: 100px"
                >
                  <span style="line-height: 40px">{{$t('i18n_contact_person')}}</span>
                </div>

                <div class="grid-content">
                  <el-input
                    v-model="submitForm.name"
                    :placeholder="addPls('i18n_contact_person', 'input')"
                    style="width: 230px"
                  ></el-input>
                </div>
              </div>
              <div style="display: flex">
                <div
                  class="grid-content"
                  style="
                    margin-left: 10px;
                    margin-right: 10px;
                    min-width: 75px;
                  "
                >
                  <span style="line-height: 40px">{{$t('i18n_contact_info')}}</span>
                </div>

                <div class="grid-content">
                  <el-input
                    v-model="submitForm.tel"
                    :placeholder="addPls('i18n_contact_info', 'input')"
                    style="width: 220px"
                  ></el-input>
                </div>
              </div>
            </el-row>

            <el-row :gutter="20" style="margin-bottom: 8px">
              <el-col :span="4"
                ><div class="grid-content">
                  <span style="line-height: 1;word-break: break-word">{{$t('i18n_contact_address')}}</span>
                </div></el-col
              >
              <el-col :span="18">
                <div class="grid-content">
                  <!-- <el-cascader
                    v-if="getLIstType == 'PS'"
                    :options="jackCitylist"
                    placeholder="请选择派送地址"
                    v-model="value"
                    clearable
                    @change="handleChange"
                    :props="props"
                  >
                  </el-cascader> -->
                  <el-cascader
                    :options="jackCitylist"
                    :placeholder="addPls('i18n_pickup_address', 'select')"
                    v-model="value"
                    clearable
                    @change="handleChange"
                    :props="defaultParams2"
                    style="width: 260px"
                  >
                  </el-cascader>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" style="margin-bottom: 8px">
              <el-col :span="4"
                ><div class="grid-content">
                  <div
                    style="line-height: 40px; width: 10px; height: 10px"
                  ></div></div
              ></el-col>
              <el-col :span="18"
                ><div class="grid-content">
                  <el-input
                    v-model="submitForm.address"
                    type="textarea"
                    rows="2"
                    :placeholder="addPls('i18n_Detailed_address', 'input')"
                  ></el-input></div
              ></el-col>
            </el-row>
            <el-row :gutter="20" style="margin-bottom: 8px">
              <el-col :span="4"
                ><div class="grid-content">
                  <span style="line-height: 40px">{{$t('i18n_label')}}</span>
                </div></el-col
              >
              <el-col :span="18"
                ><div class="grid-content">
                  <el-input
                    v-model="submitForm.tag"
                    :placeholder="addPls('i18n_label', 'input')"
                  ></el-input></div
              ></el-col>
            </el-row>

            <div style="width: 330px; margin: 0 auto; text-align: center">
              <div style="display: flex">
                <el-checkbox
                  text-color="#5AB53C"
                  v-model="submitForm.isdefault"
                  style="margin-right: 10px"
                ></el-checkbox>
                <span style="display: block; margin-bottom: 8px">
                  {{$t('i18n_set_to_default_address')}}
                </span>
              </div>
              <el-button
                @click="addAddr"
                style="
                  background: #5AB53C;
                  border: 1px solid #5AB53C;
                  border-radius: 5px;
                  color: #fff;
                "
                >{{ $t(submitForm.id ? "i18n_edit" : "i18n_add") }}</el-button
              >
              <el-button type="info" @click="showAdd(false)">{{$t('i18n_Close')}}</el-button>
            </div>
          </div>
        </div>

        <el-table
          v-if="!edit"
          @row-click="rowClick"
          size="mini"
          height="300"
          tooltip-effect="dark"
          :data="tableData"
          max-height="200"
          highlight-current-row
          border
          ref="Table"
          style="width: 100%; overflow: hidden;"
        >
          <el-table-column
            :label="$t('i18n_Name')"
            width="100"
            align="center"
            prop="name"
          >
          </el-table-column>
          <el-table-column :label="$t('i18n_Phone')" width="120" align="center" prop="tel">
          </el-table-column>
          <el-table-column
            :label="$t('i18n_contact_address')"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.parvince }}
              {{ scope.row.country }}
              {{ scope.row.city }}
              {{ scope.row.area }}
              {{ scope.row.address }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('i18n_Operation')" align="center" width="200">
            <!-- <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="请输入姓名"
            />
          </template> -->
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click.stop="setDefault(scope.row)"
              >
                <span
                  :style="
                    scope.row.isdefault ? 'color:#604AFF' : 'color:#9A9A9A'
                  "
                  >{{ $t(scope.row.isdefault ? "i18n_Default" : "i18n_set_to_default") }}</span
                >
              </el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleEdit(scope.$index, scope.row)"
                >{{$t('i18n_edit')}}</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click.stop="handleDeleteAddress(scope.$index, scope.row)"
                >{{$t('i18n_delete')}}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          v-if="!edit"
          style="margin-top: 20px"
          :title="$t('i18n_Click_line_select_address')"
          type="info"
          center
          show-icon
        >
        </el-alert>
      </div>
    </el-dialog>
    <!-- 修改地址 -->
    <el-dialog
      class="dialog"
      width="480px"
      :visible.sync="addressDialogVisible"
      :closeOnClickModal="false"
      destroy-on-close
    >
      <div class="wrap_count">
        <div class="header_logo">
          {{ $t(!itemid ? "i18n_Create_new_address" : "i18n_Modify_Address") }}
        </div>
        <div class="count">
          <el-form label-position="right" label-width="125px" :rules="fromPopRules" :model="fromPop" ref="editAddress">
            <el-form-item :label="$t('i18n_contact_person')" prop="name">
              <el-input
                :placeholder="addPls('i18n_contact_person', 'input')"
                v-model="fromPop.name"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('i18n_contact_info')" prop="tel">
              <el-input
                :placeholder="addPls('i18n_contact_info', 'input')"
                v-model="fromPop.tel"
              ></el-input>
            </el-form-item>
            <!-- 国内省市区 -->
            <el-form-item :label="$t('i18n_contact_address')" v-if="changeNum == 2" prop="ssqnames">
              <el-cascader
                style="width: 100%"
                ref="refSsqname"
                :options="Guojialist"
                v-model="fromPop.ssqnames"
                :props="defaultParams"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.namec }}</span>
                  <span v-if="!node.isLeaf"></span>
                </template>
              </el-cascader>
            </el-form-item>
            <!-- 国外区域 -->
            <el-form-item :label="$t('i18n_contact_address')" v-if="changeNum == 3" prop="ssqnames">
              <el-cascader
                style="width: 100%"
                ref="refSsqname"
                :options="citylist"
                v-model="fromPop.ssqnames"
                :props="defaultParams"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.namec }}</span>
                  <span v-if="!node.isLeaf"></span>
                </template>
              </el-cascader>
            </el-form-item>
            <el-form-item v-if="changeNum != 1">
              <el-input
                :placeholder="addPls('i18n_Detailed_address', 'input')"
                type="textarea"
                v-model="fromPop.address"
              ></el-input>
            </el-form-item>
            <el-form-item prop="type">
              <el-checkbox-group v-model="fromPop.isdefault">
                <el-checkbox name="type">{{$t('i18n_set_to_default_address')}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">{{
                $t(itemid ? "i18n_edit" : "i18n_add")
              }}</el-button>
              <el-button @click="addressDialogVisible = false">{{$t('i18n_cancel')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs"
import { addPls } from '@/utils/placeholderI18n'
export default {
  props: {
    sendFeeForAir: {
      type: Object,
      default: {}
    },
    getGoodsDTO: {
      type: Object,
      default: {}
    },
    recGoodsDTO: {
      type: Object,
      default: {}
    },
    delGoodsDTO: {
      type: Object,
      default: {}
    },
    toDoorForm: {
      type: Object,
      default: {}
    },
    cangkuitem: {
      type: Object,
      default: {}
    }
  },
  data() {
    const phoneNumberValidate = (rule, value, callback) => {
      const reg = /^(1[3-9][3-9])\d{8}$/
      if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      pickerSetTime: {
        disabledDate(time) {
          if (localStorage.getItem("todoorTime")) {
            return time.getTime() < Date.now();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      goodsTypeShow: false,
      getGoodsDTORules: {
        getGoodsAddress: [{ required: true, message: this.addPls('i18n_pickup_location', 'select'), trigger: 'change' }],
        getGoodsName: [{ required: true, message: this.addPls('i18n_pickup_person', 'select'), trigger: 'change' }],
        getGoodsTel: [{ required: true, message: this.addPls('i18n_pickup_contact_number', 'select'), trigger: 'change' }],
        toDoorDate: [{ required: true, message: this.addPls('i18n_pickup_time', 'select'), trigger: 'change' }]
      },
      TipopList: [],
      showReceive: false,
      SHpopList: [],
       //发货
      countLIst_S: {
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      showFa: false,
      FapopList: [],
      addressDialogVisible: false,
      citylist: [],
      itemid: '',
      fromPop: {
        address: "",
        parvince: "",
        city: "",
        area: "",
        country: "",
        customerid: null,
        id: "",
        isdefault: true,
        name: "",
        tag: "",
        tel: "",
        ssqnames: []
      },
      fromPopRules: {
        name: [{ required: true, message: this.addPls('i18n_contact_person', 'input'), trigger: 'blur' }],
        tel: [
          { required: true, message: this.addPls('i18n_Phone_number', 'input'), trigger: 'blur' },
          // { validator: phoneNumberValidate, trigger: 'blur' }
          { max: 20, message: this.$t('i18n_no_more_than_20_characters'), trigger: 'blur' }
        ],
        ssqnames: [{ required: true, message: this.$t('i18n_contact_address', 'input'), trigger: 'change' }],
        address: [{ required: true, message: this.addPls('i18n_Detailed_address', 'input'), trigger: 'change' }]
      },
      changeNum: null, //1 发货 2提货3收货
      Guojialist: [],
      defaultParams: {
        //定义 联级选择器的 -省市区-和-收货地址-需获取name
        label: "namec",
        value: "namec",
        children: "children",
      },
      ssqnames: [],
      showMydialog: false,
      edit: false,
      nameOrPhone: '',
      submitForm: {
        address: '',
        area: '',
        city: '',
        customerid: 0,
        id: 0,
        isdefault: false,
        name: '',
        parvince: '',
        tag: '',
        tel: ''
      },
      getLIstType: 'PS',
      jackCitylist: [],
      value: [],
      tableData: [],
      tempTableData: [],
      defaultParams2: {
        value: "namec",
        label: "namec"
      }
    }
  },
  created() {
    this.getSHdata()
    this.getFadata()
    this.gettihuoLIst()
  },
  methods: {
    ShowTHList() {
      this.getPeopletable()
      this.showMydialog = true
    },
    getPeopletable() {
      //获取提货联系人
      let that = this;
      let customerId = sessionStorage.getItem("Authorization")
        ? JSON.parse(sessionStorage.getItem("Authorization")).customerid
        : "";
      let path = "addressListForDelivery";
      // if (this.getLIstType === "PS") {
      //   path = "addressListForConsigner";
      // } else {
      //   // 暂时不调这个接口
      //   return
      // }
      this.axios.get(`/customer/${path}/${customerId}`).then((res) => {
        if (res.data.code == "200") {
          // res.data.datas.forEach((item) => {
          //   this.$set(item, "changeType", false);
          // });
          this.tableData = res.data.datas;
          this.tempTableData = res.data.datas;
        } else {
        }
      })
      .catch((res) => {});
    },
    addNewpop(num) {
      this.itemid = "";
      this.changeNum = num;
      this.fromPop.name = "";
      this.fromPop.tel = "";
      this.ssqnames = [];
      this.fromPop.ssqnames = []
      this.fromPop.address = "";
      this.addressDialogVisible = true;
      if (num != "1") {
        //1是发货人 没有省市区
        this.getProvinces(num); //查询省市区
      }
    },
    changeShitem(item) { // 选择收货人
      console.log(item);
      this.sendFeeForAir = Object.assign(this.sendFeeForAir, item);
      this.showReceive = false;
      Object.keys(this.recGoodsDTO).map(key => {
        const itemKey = key.slice(8).toLowerCase()
        this.recGoodsDTO[key] = item[itemKey]
      })

      localStorage.setItem("sendFeeForAir", JSON.stringify(this.sendFeeForAir));

      // this.getPSFcount(); //重新计算配送费
    },
    changeFAitem(item) { // 选择发货人
      this.showFa = false;
      this.countLIst_S = item;
      localStorage.setItem("countLIst_S", JSON.stringify(item));
      Object.keys(this.delGoodsDTO).map(key => {
        const itemKey = key.slice(8).toLowerCase()
        this.delGoodsDTO[key] = item[itemKey]
      })
    },
    changeshowType(num, item, type) { //设为默认
      this.axios.post(
          `/customer/updateAddressDefault?${qs.stringify({
            addressId: item.id,
          })}`
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            num == 1
              ? this.getFadata()
              : num == 2
              ? this.getTidata()
              : this.getSHdata();
            this.$message({ message: res.data.message, type: "success" });
          } else {
            this.$message(res.data.message);
          }
        });
      if (num == 1 && type == "loca") {
        item.isdefault = true;
        let countLIst_S = JSON.parse(localStorage.getItem("countLIst_S"));
        countLIst_S.isdefault = true;
        localStorage.setItem("countLIst_S", JSON.stringify(countLIst_S));
      } else if (num == 2 && type == "loca") {
        item.isdefault = true;
        let countLIst_T = JSON.parse(localStorage.getItem("countLIst_T"));
        countLIst_T.isdefault = true;
        localStorage.setItem("countLIst_T", JSON.stringify(countLIst_T));
      } else if (num == 3 && type == "loca") {
        item.isdefault = true;
        let sendFeeForAir = JSON.parse(localStorage.getItem("sendFeeForAir"));
        sendFeeForAir.isdefault = true;
        localStorage.setItem("sendFeeForAir", JSON.stringify(sendFeeForAir));
      }
    },
    UpItem(num, item) { // 修改发货收货信息
      console.log(num);
      this.itemid = item.id;
      this.getProvinces(num);
      this.ssqnames = [];
      this.changeNum = num;
      this.addressDialogVisible = true;
      this.fromPop = JSON.parse(JSON.stringify(item));
      this.fromPop.ssqnames = []
      // console.log(this.fromPop);
      if (num == 2) {
        this.fromPop.ssqnames[0] = item.parvince;
        this.fromPop.ssqnames[1] = item.city;
        this.fromPop.ssqnames[2] = item.area;
      } else if (num == 3) {
        this.fromPop.ssqnames[0] = item.country;
        this.fromPop.ssqnames[1] = item.city;
        this.fromPop.ssqnames[2] = item.area;
      }
    },
    getProvinces(num) { //获取省市区和国外地址
      let url = "";
      if (num == 3) {
        //国外城市和区域 2是国外 3是国内
        url = "/filedata/findThirdLevelAddress";
        this.axios.post(url).then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.citylist = res.data.datas;
            this.jackCitylist = res.data.datas;
          } else {
          }
        }).catch((res) => {
          console.log(res);
        });
      } else {
        //国内省市区
        url = "/filedata/filedataProvinces";
        this.axios.post(url).then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.Guojialist = res.data.datas;
            this.jackCitylist = res.data.datas;
          } else {
          }
        }).catch((res) => {
          console.log(res);
        });
      }
    },
    onSubmit() {
      this.$refs.editAddress.validate(valid => {
        if (!valid) return
        console.log(this.changeNum);
        let that = this;
        //changeNum //1 发货 2提货3收货
        // if (!this.fromPop.name) return this.$message("请输入联系人姓名");
        // if (!this.fromPop.tel) return this.$message("请输入联系人电话");
        if (this.changeNum == 1) {
          //新增发货
          let params = {
            customerid: JSON.parse(sessionStorage.getItem("Authorization"))
              .customerid, //客户id
            id: this.itemid,
            isdefault: this.fromPop.isdefault,
            name: this.fromPop.name,
            tag: "",
            tel: this.fromPop.tel,
          };
          this.axios.post(`/customer/addOrUpdateShipper`, params).then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.$message({ message: res.data.message, type: "success" });
              if (this.countLIst_S.id == this.itemid) {
                //为了更新本地默认通讯录信息
                this.countLIst_S = params;
                localStorage.setItem("countLIst_S", JSON.stringify(params));
              }
              this.getFadata();
              this.addressDialogVisible = false;
            } else {
              this.$message(res.data.message);
            }
          });
        } else if (this.changeNum == 2) {
          // if (this.fromPop.ssqnames.length == 0) return this.$message("请选择联系地址");
          // if (!this.fromPop.address) return this.$message("请输入详细地址");
          let params = {
            customerid: JSON.parse(sessionStorage.getItem("Authorization"))
              .customerid, //客户id
            id: this.itemid,
            isdefault: this.fromPop.isdefault,
            name: this.fromPop.name,
            tag: "",
            tel: this.fromPop.tel,
            parvince: this.ssqnames[0],
            city: this.ssqnames[1],
            area: this.ssqnames[2],
            address: this.fromPop.address,
          };
          this.axios.post(`/customer/addOrUpdateDelivery`, params).then((res) => {
            if (res.data.code == "200") {
              this.$message({ message: res.data.message, type: "success" });
              this.getTidata();
              this.addressDialogVisible = false;
            } else {
              this.$message(res.data.message);
            }
          });
        } else {
          //新增或修改收货人
          // if (this.fromPop.ssqnames.length == 0) return this.$message("请选择联系地址");
          // if (!this.fromPop.address) return this.$message("请输入详细地址");
          let params = {
            customerid: JSON.parse(sessionStorage.getItem("Authorization"))
              .customerid, //客户id
            id: this.itemid,
            isdefault: this.fromPop.isdefault,
            name: this.fromPop.name,
            tag: "",
            tel: this.fromPop.tel,
            country: this.fromPop.ssqnames[0],
            city: this.fromPop.ssqnames[1],
            area: this.fromPop.ssqnames[2],
            address: this.fromPop.address,
            //为了保存到本地赋值
            countryId: this.fromPop.countryId,
            cityId: this.fromPop.cityId,
            areaId: this.fromPop.areaId,
          };
          this.axios.post(`/customer/addOrUpdateConsigner`, params).then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.$message({ message: res.data.message, type: "success" });
              if (this.sendFeeForAir.id == this.itemid) {
                //为了更新本地默认通讯录信息
                this.sendFeeForAir = Object.assign(this.sendFeeForAir, params);
                localStorage.setItem("sendFeeForAir", JSON.stringify(params));
              }
              this.getSHdata();
              this.addressDialogVisible = false;
            } else {
              this.$message(res.data.message);
            }
          });
        }
      })
    },
    getPeopletable() {
      //获取提货联系人
      let that = this;
      let customerId = sessionStorage.getItem("Authorization")
        ? JSON.parse(sessionStorage.getItem("Authorization")).customerid
        : "";
      let path = "addressListForDelivery";
      // if (this.getLIstType === "PS") {
      //   path = "addressListForConsigner";
      // } else {
      //   // 暂时不调这个接口
      //   return
      // }
      this.axios.get(`/customer/${path}/${customerId}`).then((res) => {
        if (res.data.code == "200") {
          // res.data.datas.forEach((item) => {
          //   this.$set(item, "changeType", false);
          // });
          this.tableData = res.data.datas;
          this.tempTableData = res.data.datas;
        } else {
        }
      })
      .catch((res) => {});
    },
    closeMyDialog() { // 提货人dialog
      if (this.edit) {
        this.$confirm(this.$t("i18n_status_is_edit_close"), this.$t("i18n_hint"), {
          confirmButtonText: this.$t("i18n_confirm"),
          cancelButtonText: this.$t("i18n_cancel"),
          type: "warning",
        })
          .then(() => {
            this.showMydialog = false;
            this.showAdd(false);
          })
          .catch((res) => {});
      } else {
        this.showMydialog = false;
      }
    },
    // 显示新增
    showAdd(type) {
      if (type) {
        this.edit = true;
      } else {
        this.edit = false;
      }

      this.value = [];
      for (let key in this.submitForm) {
        this.submitForm[key] = "";
      }
    },
    // 模糊搜索
    searchNameOrPhone() {
      if (!this.nameOrPhone) {
        return this.getPeopletable();
      }
      let temp = [];

      this.tempTableData.forEach((item, index) => {
        if (
          item.name.indexOf(this.nameOrPhone) != -1 ||
          item.tel.indexOf(this.nameOrPhone) != -1
        ) {
          temp.push(item);
        }
      });
      this.tableData = temp;
    },
    getTidata() {
      //获取提货人
      let that = this
      let customerId = JSON.parse(sessionStorage.getItem("Authorization")).customerid
      this.axios.get(`/customer/addressListForDelivery/${customerId}`).then((res) => {
        if (res.data.code == "200") {
          this.TipopList = res.data.datas
        }
      }).catch((res) => {
        console.log(res)
      })
    },
    getSHdata() {
      //收货人
      let that = this;
      let customerId = JSON.parse(sessionStorage.getItem("Authorization")).customerid
      this.axios.get(`/customer/addressListForConsigner/${customerId}`).then((res) => {
        console.log(res)
        if (res.data.code == "200") {
          this.SHpopList = res.data.datas
          if (localStorage.getItem("sendFeeForAir")&&this.recGoodsDTO.recGoodsName) {
            //如果有选择收货费
            this.SHpopList.forEach(item => { // 更新当前收货人的默认状态
              if (item.id === this.sendFeeForAir.id) {
                this.sendFeeForAir = Object.assign(this.sendFeeForAir, item)
              }
            })
          } else {
            //如果没有选择就显示默认
            res.data.datas.forEach((item) => {
              if (item.isdefault) {
                this.sendFeeForAir = Object.assign(this.sendFeeForAir, item);
                Object.keys(this.recGoodsDTO).map(key => {
                  const itemKey = key.slice(8).toLowerCase()
                  this.recGoodsDTO[key] = item[itemKey]
                })
              }
            })
            localStorage.setItem("sendFeeForAir", JSON.stringify(this.sendFeeForAir))
          }
        }
      })
      .catch((res) => {
        console.log(res)
      })
    },
    getFadata() {
      //发货人
      let customerId = JSON.parse(sessionStorage.getItem("Authorization"))
        .customerid;
      this.axios.get(`/customer/addressListForShipper/${customerId}`).then((res) => {
        if (res.data.code == "200") {
          this.FapopList = res.data.datas;
          if (sessionStorage.getItem("countLIst_S")&&this.delGoodsDTO.delGoodsName) {
            this.FapopList.forEach(item => { // 更新当前发货人的默认状态
              if (item.id === this.countLIst_S.id) {
                this.countLIst_S = Object.assign(this.countLIst_S, item)
              }
            })
          } else {
            // 本地没有就循环数据索取默认
            res.data.datas.forEach((item) => {
              if (item.isdefault) {
                this.countLIst_S = item;
                Object.keys(this.delGoodsDTO).map(key => {
                  const itemKey = key.slice(8).toLowerCase()
                  this.delGoodsDTO[key] = item[itemKey]
                })
              }
            });
            localStorage.setItem(
              "countLIst_S",
              JSON.stringify(this.countLIst_S)
            );
          }
        } else {
        }
      })
      .catch((res) => {
        console.log(res);
      });
    },
    // 级联选择器方法
    handleChange(value) {
      // if (this.getLIstType === "PS") {
      //   this.submitForm.country = value[0];
      // } else {
      //   this.submitForm.parvince = value[0];
      // }
      this.submitForm.parvince = value[0];
      this.submitForm.city = value[1];
      this.submitForm.area = value[2];
    },
    // add
    addAddr(id) {
      console.log(1)
      if (!this.very()) {
        return;
      }
      if (!this.submitForm.id) {
        delete this.submitForm.id;
      }
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      // 新增
      this.submitForm.customerid = user.customerid;
      // 判断是否是派送
      let path = "addOrUpdateDelivery";
      // if (this.getLIstType === "PS") {
      //   path = "addOrUpdateConsigner";
      // }
      this.axios.post(`/customer/${path}`, this.submitForm, {}).then((res) => {
        if (res.data.code == 200) {
          this.edit = false;
          this.value = [];
          this.getPeopletable();
          for (let key in this.submitForm) {
            this.submitForm[key] = "";
          }
        } else {
          this.$message.info(res.data.message);
        }
      })
      .catch((res) => {});
    },
    rowClick(r) {
      console.log(r)
      // if (this.getLIstType === "PS") {
      //   this.countLIst_C = r;
      //   localStorage.setItem("countLIst_C", JSON.stringify(this.countLIst_C));
      // } else {
      //   this.countLIst_T = r;
      //   localStorage.setItem("countLIst_T", JSON.stringify(this.countLIst_T));
      // }
      Object.keys(this.getGoodsDTO).forEach(key => {
        const rowKey = key.slice(8).toLowerCase()
        this.getGoodsDTO[key] = r[rowKey]
      })
      this.getGoodsDTO.getGoodsProvince = r.parvince
      this.getGoodsDTO.toDoorDate = this.toDoorForm.toDoorDate
      this.$emit('rowClick')
      this.showMydialog = false;
    },
    // 设为默认
    setDefault(item) {
      if (item.isdefault) {
        return this.$message.info(this.$t("i18n_Already_default_address"));
      }
      this.axios.post(`/customer/updateAddressDefault?addressId=${item.id}`, {}).then((res) => {
        if (res.data.code == 200) {
          this.getPeopletable();
          this.$message.success(this.$t("i18n_Success"));
        } else {
          this.$message.info(res.data.message);
        }
      })
      .catch((res) => {});
    },
    ShowTHList() {
      this.getPeopletable()
      this.showMydialog = true
    },
    //  edit
    handleEdit(index, item) {
      console.log('sss', item)
      this.value = [];
      let temp = JSON.stringify(item);
      this.getProvinces(2)
      this.submitForm = JSON.parse(temp);
      this.value.push(
        // this.getLIstType == "PS"
        //   ? this.submitForm.country
        //   : this.submitForm.parvince,
        this.submitForm.parvince,
        this.submitForm.city,
        this.submitForm.area
      );
      this.edit = true;
    },
    // 删除地址
    handleDeleteAddress(index, row) {
      let that = this;
      this.$confirm(this.$t("i18n_confirm_delete_address"), this.$t("i18n_hint"), {
        confirmButtonText: this.$t("i18n_confirm"),
        cancelButtonText: this.$t("i18n_cancel"),
        type: "warning",
      }).then(() => {
        that.axios.post(`/customer/delAddress/${row.id}`).then((res) => {
          if (res.data.code == "200") {
            that.$message({
              message: res.data.message,
              type: "success",
            });
            this.getPeopletable();
          } else {
            that.$message({
              message: res.data.message,
              type: "info",
            });
          }
        })
        .catch((res) => {});
      }).catch(() => {
        this.$message({
          type: "info",
          message: this.$t("i18n_Canceled"),
        });
      });
      // /customer/delAddress/{id}
    },
    // 校验
    very() {
      if (!this.submitForm.name) {
        this.$message.info(this.$t("i18n_contact_person_cant_be_empty"));
        return false;
      }
      // 派送不校验
      if (this.getLIstType != "PS") {
        if (!/^1[3456789]\d{9}$/.test(this.submitForm.tel)) {
          this.$message.info(this.$t("i18n_contact_number_incorrect"));
          return false;
        }
      }

      // 城市
      if (!this.submitForm.city) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      // 区
      if (!this.submitForm.area) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      if (!this.submitForm.address) {
        this.$message.info("详细地址不能为空！");
        return false;
      }
      if (this.submitForm.tag) {
        if (this.submitForm.tag.length > 5) {
          this.$message.info(this.$t("i18n_label_cannot_exceeds_5_characters"));
          return false;
        }
      }

      return true;
    },
    toDoorDateChange(val) { // 这里是为了更好做验证是否选择提货日期
      this.getGoodsDTO.toDoorDate = val
    },
    changeTi(val) {
      this.$emit('changeTi', val)
    },
    submit() {
      let flag
      this.$refs.getGoodsInfo.validate(valid => {
        if (valid) {
          flag = valid
        }
      })
      if(flag) {
        return flag
      }
    },
    addPls,
    gettihuoLIst() { //省市区列表
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      this.axios
        .post(`filedata/filedataProvinces`, {}, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.jackCitylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.weituo {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  .addMore {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }
}
.tittype {
  font-size: 18px;
  font-family: Helvetica, "San Francisco", "Microsoft Yahei", 微软雅黑, "Heiti SC";
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.poperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #e6e6e6;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.4s;
}
.poperWrap:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
}
.popWrap_l {
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.lianxiren {
  font-size: 18px;
  font-family: Helvetica, "San Francisco", "Microsoft Yahei", 微软雅黑, "Heiti SC";
  font-weight: bold;
  color: #343434;
  width: 70px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.overText {
  width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.morentype {
  height: 20px;
  background: #dedede;
  border-radius: 5px;
  color: #9a9a9a;
  padding: 2px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
}
.thatpoperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #5ab53c;
  background: #c7e4bd;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.popWrap_R {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.SHInfo {
  padding: 15px;
  border-radius: 5px;
  background-color: #fff6e6;
  color: #f79c00;
  &:first-child {
    margin-top: 5px;
  }
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.count {
  width: 100%;
  padding-top: 30px;
}
.wrap_count {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.header_logo {
  width: 100%;
  float: left;
  text-align: left;
}
.myDialog {
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/airOrder/component/addressInfo.vue